// Apply Info 页面相关的翻译资源
export const applyResources = {
  zh: {
    // Apply Info page
    "apply.title": "资助申请指南",
    "apply.section1.title": "补助形式及申请资格",
    "apply.section1.item1": "补助形式: 一次性现金补助",
    "apply.section1.item2": "身份要求: 申请人须为香港全日制在读博士生",
    "apply.section1.item3": "子女要求: 需2026年1月1日或之后出生的子女",
    "apply.section2.title": "申请流程及文件要求",
    "apply.section2.subsection1.title": "在线提交申请表",
    "apply.section2.subsection1.item1": "填写个人基本信息, 包括银行账户等信息",
    "apply.section2.subsection1.item2": "上传有效学生证, 须包括姓名、相片、学号、课程名称及有效注册年份",
    "apply.section2.subsection1.item3": "上传最新/近期的学生成绩表或在读证明, 须包括姓名、学号、发出日期",
    "apply.section2.subsection1.item4": "上传子女出生证明: 经出生地官方机构/医院发出的出生证明文件, 须包括父母姓名、子女出生日期及地点",
    "apply.section2.subsection2.title": "审批及发放",
    "apply.section2.subsection2.item1": "文件核实: 基金会将在收齐合规文件后的14个工作天内完成审批(保留要求申请人补交额外证明文件的权利)",
    "apply.section2.subsection2.item2": "审核标准: 申请需符合本基金会成立宗旨",
    "apply.section2.subsection2.item3": "拨款安排: 审批通过后, 补助金将于5个工作天内直接存入申请人指定银行账户",
    "apply.inquiry": "申请进度可通过基金会电邮 {email} 查询",
    "apply.email": "info@genovationfoundation.org",
    "apply.disclaimer": "如有任何争议, 基金会保留最终解释权及决定权",
    "apply.button": "立即申请",
  },
  zh_TW: {
    // Apply Info page
    "apply.title": "資助申請指南",
    "apply.section1.title": "補助形式及申請資格",
    "apply.section1.item1": "補助形式: 一次性現金補助",
    "apply.section1.item2": "身份要求: 申請人須為香港全日制在讀博士生",
    "apply.section1.item3": "子女要求: 於2026年1月1日或之後出生",
    "apply.section2.title": "申請流程及文件要求",
    "apply.section2.subsection1.title": "在線提交申請表",
    "apply.section2.subsection1.item1": "填寫個人基本信息, 包括銀行帳戶等信息",
    "apply.section2.subsection1.item2": "上傳有效學生證, 須包括姓名、相片、學號、課程名稱及有效註冊年份",
    "apply.section2.subsection1.item3": "上傳最新/近期的學生成績表或在讀證明, 須包括姓名、學號、發出日期",
    "apply.section2.subsection1.item4": "上傳子女出生證明: 經出生地官方機構/醫院發出的出生證明文件, 須包括父母姓名、子女出生日期及地點",
    "apply.section2.subsection2.title": "審批及發放",
    "apply.section2.subsection2.item1": "文件核實: 基金會將在收齊合規文件後的14個工作天內完成審批(保留要求申請人補交額外證明文件的權利)",
    "apply.section2.subsection2.item2": "審核標準: 申請需符合本基金會成立宗旨",
    "apply.section2.subsection2.item3": "撥款安排: 審批通過後, 補助金將於5個工作天內直接存入申請人指定銀行帳戶",
    "apply.inquiry": "申請進度可通過基金會電郵 {email} 查詢",
    "apply.email": "info@genovationfoundation.org",
    "apply.disclaimer": "如有任何爭議, 基金會保留最終解釋權及決定權",
    "apply.button": "立即申請",
  },
  en: {
    // Apply Info page
    "apply.title": "Grant Application Guidelines",
    "apply.section1.title": "Subsidy Form and Eligibility Criteria",
    "apply.section1.item1": "Subsidy Type: One-time cash subsidy.",
    "apply.section1.item2": "Applicant Status: Must be a full-time PhD student in Hong Kong.",
    "apply.section1.item3": "Child Requirement: Must have at least one child born on or after January 1, 2026.",
    "apply.section2.title": "Application Process and Document Requirements",
    "apply.section2.subsection1.title": "Online Application Submission",
    "apply.section2.subsection1.item1": "Fill in personal basic information, including bank account details.",
    "apply.section2.subsection1.item2": "Upload a valid student ID, which must include name, photo, student number, course name, and valid registration year.",
    "apply.section2.subsection1.item3": "Upload the latest/recent academic transcript or proof of enrollment, must include name, student ID, and issue date.",
    "apply.section2.subsection1.item4": "Upload child's birth certificate: Birth certificate issued by the official authority/hospital of the birthplace, must include parents' names, child's date and place of birth.",
    "apply.section2.subsection2.title": "Approval and Disbursement",
    "apply.section2.subsection2.item1": "Document Verification: The foundation will complete approval within 14 working days after receiving all required documents (Additional proof may be requested).",
    "apply.section2.subsection2.item2": "Review Criteria: Applications must align with the Foundation’s objectives.",
    "apply.section2.subsection2.item3": "Disbursement Arrangement: Once approved, the subsidy will be directly deposited into the applicant's designated bank account within 5 working days.",
    "apply.inquiry": "Application status can be inquired via the foundation's email at {email}",
    "apply.email": "info@genovationfoundation.org",
    "apply.disclaimer": "In case of any dispute, the foundation reserves the right of final interpretation and decision",
    "apply.button": "Apply Now",
  }
};

